















import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Schedules, User } from '@/store';
import NewCurve from '@/pages/schedules/components/curves/NewCurve.vue';
import DeleteCurve from '@/pages/curves/DeleteCurve.vue';

@Component({ components: { NewCurve, DeleteCurve } })
class EditCurve extends Vue {
  @User.State('project') project;
  @Schedules.State('userCurves') userCurves;
  @Schedules.Action('loadUserCurves') loadUserCurves;
  @Schedules.Action('loadSchedules') loadSchedules;

  curve_data = null;
  curve_to_delete = null;
  loading = true;

  mounted() {
    this.load();
  }

  /*
    The curve is read from the project's curves, which are not loaded yet when this route
    is opened directly (a shared link, a refresh) rather than from Curves Management. The
    schedules come along because deleting the curve from here has to know which schedules
    still use it.
  */
  @Watch('project')
  async load() {
    if (!this.project) return;
    this.loading = true;
    await this.loadSchedules({ projectId: this.project.id });
    await this.loadUserCurves();
    this.setCurve();
    this.loading = false;
  }

  setCurve() {
    const curve_id = this.$route.params.id;
    this.curve_data = this.userCurves.find((curve) => curve.id === curve_id) || null;
    // An id that no longer exists (deleted curve, stale link) has nothing to edit, so it
    // lands on the list instead of an empty editor.
    if (!this.curve_data) this.$router.push('/curves');
  }
}

export default EditCurve;
